<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-form ref="form" @submit.prevent="submit">
          <v-card-title>Ubah Permission</v-card-title>
          <v-card-text>
            <v-row v-if="!loading">
              <v-col cols="12">
                <ul style="list-style: none; padding-left: 0px">
                  <li v-for="(item, index) in data" :key="index">
                    <v-checkbox
                      v-model="item.is_checked"
                      :label="item.name"
                      hide-details
                      @click="clickedParent(item)"
                    ></v-checkbox>
                    <ul v-if="item.childs.length > 0" style="list-style: none">
                      <li v-for="(child, index2) in item.childs" :key="index2">
                        <v-checkbox v-model="child.is_checked" :label="child.name" hide-details></v-checkbox>
                      </li>
                    </ul>
                  </li>
                </ul>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12"> Memuat... </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="12">
                <v-btn color="primary" :loading="loadingButtonSubmit" type="submit">Simpan</v-btn>
                <v-btn color="primary" outlined class="ml-3">Batal</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>

    <v-snackbar v-model="alert.status" :timeout="timeout" :color="alert.success ? 'success' : 'error'" right bottom>
      {{ alert.message }}
    </v-snackbar>
  </v-row>
</template>

<script>
import { mdiSquareEditOutline, mdiDotsVertical, mdiRefresh, mdiFileOutline, mdiClose } from '@mdi/js'
import axios from 'axios'
export default {
  setup() {
    return {
      // icons
      icons: {
        mdiSquareEditOutline,
        mdiDotsVertical,
        mdiRefresh,
        mdiFileOutline,
        mdiClose,
      },
    }
  },
  computed: {
    user() {
      return JSON.parse(localStorage.getItem('user'))
    },
    role_id() {
      return this.$route.params.role_id
    },
  },
  data() {
    return {
      alert: {
        status: false,
        success: false,
        message: '',
      },
      timeout: 1200,
      loading: false,
      data: [],
      loadingButtonSubmit: false,
      menu_ids: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.data = []
      const token = localStorage.getItem('token')
      axios
        .get(`${process.env.VUE_APP_API_ENDPOINT}permission/${this.role_id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(res => {
          this.loading = false
          if (res.status == 200) {
            const data = res.data
            if (data.success) {
              this.data = [
                {
                  id: '',
                  name: 'Check ALL',
                  is_checked: false,
                  childs: [],
                },
                ...data.data,
              ]
            } else {
              this.alert = {
                status: true,
                success: false,
                message: data.message,
              }
            }
          } else {
            this.alert = {
              status: true,
              success: false,
              message: res.statusText,
            }
          }
        })
        .catch(err => {
          this.loading = false
          const response = err.response
          const data = response.data
          this.alert = {
            status: true,
            success: false,
            message: data.message,
          }
          if (data.message == 'Anda tidak diberikan akses!') {
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            this.$router.push({ name: 'login' })
          }
        })
    },
    clickedParent(item) {
      if (item.id == '') {
        for (const menu of this.data) {
          menu.is_checked = item.is_checked
          for (const child of menu.childs) {
            child.is_checked = item.is_checked
          }
        }
      } else {
        if (item.childs.length > 0) {
          for (const child of item.childs) {
            child.is_checked = item.is_checked
          }
        }
      }
    },
    convertDataToMenuIDS() {
      this.menu_ids = []
      for (const menu of this.data) {
        if (menu.childs.length > 0) {
          for (const child of menu.childs) {
            if (child.is_checked) {
              this.menu_ids.push(child.id)
            }
          }
        } else {
          if (menu.is_checked && menu.id != '') {
            this.menu_ids.push(menu.id)
          }
        }
      }
    },
    submit() {
      this.convertDataToMenuIDS()
      this.loadingButtonSubmit = true
      const token = localStorage.getItem('token')
      axios
        .patch(
          `${process.env.VUE_APP_API_ENDPOINT}permission/${this.role_id}`,
          { menu_ids: this.menu_ids },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
        .then(res => {
          this.loadingButtonSubmit = false
          if (res.status == 200) {
            const data = res.data
            this.alert = {
              success: data.success,
              status: true,
              message: data.message
            }
            if (data.success) {
              this.$router.go(-1)
            }
          } else {
            this.alert = {
              status: true,
              success: false,
              message: res.statusText,
            }
          }
        })
        .catch(err => {
          this.loadingButtonSubmit = false
          const response = err.response
          const data = response.data
          this.alert = {
            status: true,
            success: false,
            message: data.message,
          }
          if (data.message == 'Anda tidak diberikan akses!') {
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            this.$router.push({ name: 'login' })
          }
        })
    },
  },
}
</script>

<style>
</style>